// Teks kaya sederhana untuk konten dari R2 (bank soal, kartu rumus).
// Semua HTML di-escape dulu, lalu hanya sintaks berikut yang diubah:
//   **tebal**        -> <b>tebal</b>
//   *miring*         -> <i>miring</i> (tanda bintang tunggal yang menempel pada kata)
//   [[3|4]]          -> pecahan 3/4 (pembilang|penyebut)
//   baris baru       -> <br>
import { esc, F } from './format.js';

// Miring: *kata* yang diapit bintang tunggal tanpa spasi di sisi dalam (bukan bagian dari **tebal**).
export const MIRING = /(^|[^*\w])\*(?=[^\s*])([^*\n]*?[^\s*])\*(?![*\w])/g;
export const miring = h => h.replace(MIRING, '$1<i>$2</i>');

export function richText(s) {
  if (s == null) return '';
  let h = esc(String(s));
  h = h.replace(/\[\[([^\]|]+)\|([^\]]+)\]\]/g, (_, a, b) => F(a.trim(), b.trim()));
  h = h.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');
  h = miring(h);
  h = h.replace(/\r?\n/g, '<br>');
  return h;
}
